// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stage: 'Staging',
  type: 'saras',
  release: 'RELEASE_COMMIT',
  apiUrl: 'https://stagingwebapi.sarasanalytics.com/',
  apiUrlSourceService: "https://test-source-service.sarasanalytics.com/v1/api/",
  subscriptionApiUrl: 'https://staging-subscription-service.sarasanalytics.com/v1/api',
  studioApiUrl: 'https://stagingwebapi.sarasanalytics.com/connector-studio',
  marketingPricingPageLink : 'https://sarasanalytics.com/staging/choose-your-right-plan/',
  userServiceApiUrl: `https://user-service.sarasanalytics.com/v1/api/user`,
  notificationApiUrl: `https://staging-notifications.sarasanalytics.com/v1/api`,
  monitoringApiUrl: `https://staging-monitoring-service.sarasanalytics.com/v1/api`,
  vmUrl: 'https://staging-notifications.sarasanalytics.com/v1/api/',
  insightsApiUrl: 'https://staging-insights-service.sarasanalytics.com',
  mixpanelProjectToken: '7fbb8d4879b82bcc65bbda14b81232fc',
  chargeBeeSite: 'sarasanalytics-test',
  agGridLicense: 'Using_this_{AG_Grid}_Enterprise_key_{AG-085730}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Saras_Analytics_LLC}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{2_May_2026}____[v3]_[01]_MTc3NzY3NjQwMDAwMA==04a53dc5e4f7c2f25891868e2381708a',
  glowroot: {
    server1: '',
    server2: ''
  },
  firebaseConfig :  {
    apiKey: 'AIzaSyDfh2bgYUAZPYB9Y0z-bS77__gtEbaKJPk',
    authDomain: 'daton-210514.firebaseapp.com',
    databaseURL: 'https://daton-210514.firebaseio.com',
    projectId: 'daton-210514',
    storageBucket: 'daton-210514.appspot.com',
    messagingSenderId: '407696326090',
    appId: '1:407696326090:web:200ec20ecf19250918a333'
  },
  filestackConfig: {
    apiKey: 'ARlI6nnkOSJqOMEJo5Clpz',
    appSecret: '5HBLGKB3RBAKLMQ35HUFTYQN3A'
  },
  allowTemplatesFeatureOnlyForTemplateAdmin: true,
  ALLOWED_TEMPLATE_ROLES: ['TemplateAdmin', 'Admin'],
  RESTRICTED_TEMPLATE_PLANS: ['starter', 'growth', 'lite', 'starter_yearly', 'growth_yearly', 'business_yearly', 'liteyearly', 'trial'],
  ALLOWED_TEMPLATE_PLANS: ['enterprise', 'enterprise_yearly'],
  ALLOWED_STUDIO_ROLES: ['TemplateAdmin', 'Admin'],
  ALLOWED_SUBSCRIPTION_ROLES: ['OrganizationAdmin', 'Admin', 'OrganizationUser', 'SarasAdmin'],
  ALLOWED_OLD_SUBSCRIPTION_ROLES: ['OrganizationAdmin', 'Admin'],
  STUDIO_SOURCE_TYPE: 'TESTSOURCETYPE',
  CDK_ENABLED_SOURCES: [
    'MNTN',
    'CALENDLY',
    'CIN7',
    'KIBOCOMMERCE',
    'RECHARGEPAYMENTS_CDK',
    'GLADLY',
    'OHI',
    'BOLADS',
    'MAILCHIMP1',
    'WALMART_CDK',
    'BOLRETAIL_CDK',
    'FULFIL',
    'BIGCOMMERCE_CDK',
    'CLICKUP',
    'ALCHEMER',
    'BOLDCOMMERCE',
    'WOOCOMMERCE_CDK',
    'KLAVIYO_V2',
    'TIMEDOCTOR',
    'GITLAB',
    'UPSCRIBE_V2',
    'KUSTOMER_CDK',
    'SUGARCRM',
    'BYRD',
    'IMPACT',
    'LOOPRETURNS',
    'SHOPIFY_V2',
    'EPALLET_ERP',
    'SKUBANA',
    'SURVEYMONKEY_V2',
    'SKUBANA',
    'INVENTORYPLANNER',
    'AWTOMIC_V2',
    'TABOOLA',
    'SHIPBOB'
  ],
  THRESHOLD: 100000,
  PRODUCTS: {
    DATON: 'https://daton.sarasanalytics.com/login',
    PULSE: 'https://pulse.sarasanalytics.com/login',
    INSIGHTS: 'https://pulse.sarasanalytics.com/login',
    SARAS: 'https://accounts.sarasanalytics.com/auth',
  },
  PRODUCTFRUIT_KEY: 'wzcv1x771OHokILm',
  PRODUCTFRUIT_LOCAL_KEY: 'W77iH8gIE8k6eHhg',
  pfCancellationSurveyId: '26938be1-d791-4909-bcf5-b36f66c89a4d',
  isCACPhaseTwoFeatureEnabled: false,
  sentryDsn: "https://6d616948f3021e4efa9acc3dbb5519f9@o1070489.ingest.us.sentry.io/4510893918453760",
  recaptchaSiteKey: 'YOUR_RECAPTCHA_SITE_KEY',
  posthog: {
    apiKey: 'phc_oiZzNHsDGUfae8ZyiU7hY5mrAARxfXRBsP8Ms3yv3Upn',
    apiHost: 'https://replay.sarasanalytics.com',
  },
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
